<template>
    <div>
        <div v-if="!loading" class="fill-height pt-2" :class="{ 'd-flex align-center justify-center': loading }">
			<!-- card -->
			<v-card :width="$vuetify.breakpoint.width - 100"  class="week-card rounded-lg">
				<v-card-text dir="auto">  
					<div v-if="$vuetify.breakpoint.mdAndDown" class="d-flex justify-space-between">
						<div 
							v-if="userTypeUser === userType.Admin || userTypeUser === userType.Administrative" 
							class="d-flex"
						>
							<v-icon color="primary" class="me-2"> mdi-account </v-icon>
							<v-autocomplete
								v-model="userIdUser"
								:items="usersWithoutPag"
								:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
								item-value="id"
								label="Employees"
								@change="getActivePlanForUser()"
							/>
						</div>
					</div>
					<v-row class="d-flex justify-center py-3">
						<v-col 
							cols="2" 
							v-if="(userTypeUser === userType.Admin && $vuetify.breakpoint.lgAndUp) || 
							(userTypeUser === userType.Administrative && $vuetify.breakpoint.lgAndUp)" 
							class="d-flex"
						>
							<v-icon color="primary" class="me-2"> mdi-account </v-icon>
							<!-- {{usersWithoutPag[0].employee}} -->
							<v-autocomplete
								v-model="userIdUser"
								:items="usersWithoutPag"
								:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
								item-value="id"
								label="Employees"
								@change="getMatchingPlan()"
							/>
						</v-col>
				
						<v-spacer /> 
					
						<v-col cols="auto" align-self="center" class="px-0">
							<!-- previous() -->
							<a @click="previous = true; getPlanBetweenTwoDate()">
								<v-img src="../../assets/Vectors/Group 9.png" contain width="25" />
							</a>
						</v-col>
						<v-col align-self="center" cols="auto">
							<span>
								{{ startDatePlan ? 
									moment(startDatePlan).format('dddd') 
									+ ' ' 
									+ moment(startDatePlan).format('llll').split(' ')[2] 
									+ '  ' + moment(startDatePlan).format('llll').split(' ')[1] 
									: 'Start Date'
								}} - 
							
								{{ endDatePlan ? 
									moment(startDatePlan).format('dddd') 
									+ ' ' 
									+ moment(endDatePlan).format('llll').split(' ')[2] 
									+ '  ' + moment(endDatePlan).format('llll').split(' ')[1]  
								: 'End Date' 
								}}
							</span>
						</v-col>
						<v-col cols="auto" align-self="center" class="px-0" >
							<!-- next() -->
							<a @click="previous = false; getPlanBetweenTwoDate()">
								<v-img src="../../assets/Vectors/Group 9.png" contain width="25" class="reverse-icon" />
							</a>
						</v-col>
						<v-spacer />
					
					</v-row>
						
					<v-divider v-if="!loading"  class="" />	
					<template v-if="!loading">
						<v-col v-for="(day, i) in week" :key="i" class="py-0" >
							<!-- new line -->
							<v-row 
								align="center" 
								class="h-one-row d-flex flex-wrap my-3"
								style= "height: auto"
								:class="{'h-auto my-3': $vuetify.breakpoint.mdAndDown}"
							>
								<!-- day name -->
								<v-col cols="1" align-self="center" class="text-center">
									<p class="mb-0 fw-4 text--color"> 
										{{ moment(moment(day.date)).format('YYYY-MM-DD').split('-')[2] }}
									</p>
									<p class="mb-0"> {{ day.name }} </p>
								</v-col>

								<v-divider vertical class="my-0" />
				
								<!-- <v-col v-if="!day.tasks.length"  class="text-center" align-self="center">
									<v-btn
										v-if="
											($route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day'))
											|| ($route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days')))
										"
										@click="rowId = day.id; dialog = true"
										text
										class="Urbanist-font text-none hover"
										:disabled="noPlan"
									
									>
										
										<v-icon size="35" color="success-light" class="mx-2"> mdi-plus-circle </v-icon>
										Add Task
									</v-btn>
								</v-col> -->
								<v-col 
									class="text-center py-1 d-flex flex-wrap" 
									style="width: 100%"
									align-self="center"
								>
									<div
										id="demo"
										v-for="(task, r) in day.tasks" 
										:key="r"
										class="my-1 pa-1 mx-1 rounded-lg w-100"
										style="width: 100%"
										:class="{ 
											'task-card-done': task.isDone,
											'task-card': !task.isDone && $vuetify.breakpoint.lgAndUp,
											'h-auto my-1': $vuetify.breakpoint.lgAndDown,
											'my-grey': !task.isDone,
										}"
									>
										<v-col class="h-100 pt-0 d-flex flex-column">
											<v-row class="mt-0 pt-0">
												<v-col cols="7" class="py-0 text-start ">
													<span 
														class=" fs-12" 
														:class="{
															'white--text': task.isDone || $vuetify.theme.dark,
															'primary--text': !task.isDone && !$vuetify.theme.dark,
														}"
													> 
														{{
															userTypeUser === userType.Developer ?
															currentUserProjects.find(c => c.id === task.projectId)?.name :
															allProjects.find(c => c.id === task.projectId)?.name
														}}
													</span>
												</v-col>
												<v-col cols="5" class="py-0 text-end">
													<span>
														<span
															class="px-2 py-1 rounded-pill fs-11"
															:class="{ 
																'no-task-style-green bg-light-green': task.isDone,
																'bg-light-blue': !$vuetify.theme.dark && !task.isDone,
																'bg-light-grey white--text':  $vuetify.theme.dark && !task.isDone,
																'no-task-style': !task.isDone
															}"
														> 
															{{ task.taskNo }} 
														</span>
													</span>
												</v-col>
											</v-row>
											<!-- text -->
											<v-row>
												<v-col class="text-start py-0 line-h-1-3">
													<!-- 'black--text': $vuetify.theme.dark && !task.isDone -->
													<span v-if="$vuetify.breakpoint.width < 1800" class="fs-12" 
														:class="{ 
															'white--text': task.isDone,	
														}"
														dir="auto"
													>
														{{	
															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
																(Number(((task.durationInMinute)/60).toFixed(2))) < 2 
															) ? 
															task.content.length > 35 ? (task.content.slice(0, 35) + '...'): task.content :

															(
																(Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
																(	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
																	((((task.durationInMinute)/60).toFixed(2))) > 2
																) 
															) ? 
															task.content.length > 55 ? (task.content.slice(0, 55) + '...'): task.content  : 

															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
																( 
																	(Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 3
																) 
															)? 
															task.content.length > 68 ? (task.content.slice(0, 68) + '...'): task.content 

															: task.content.length > 70 ? (task.content.slice(0, 70) + '...') : task.content
														}}
													</span>

													<span v-if="$vuetify.breakpoint.width >= 1800" class="fs-12">
														
														{{	
															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
																(Number(((task.durationInMinute)/60).toFixed(2))) < 2 
															) ? 
															task.content.length > 60 ? (task.content.slice(0, 60) + '...'): task.content :

															(
																(Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
																(	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 2
																) 
															) ? 
															task.content.length > 90 ? (task.content.slice(0, 90) + '...'): task.content  : 

															( 
																(Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
																( 
																	(Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
																	(Number(((task.durationInMinute)/60).toFixed(2))) > 3
																) 
															)? 
															task.content.length > 100 ? (task.content.slice(0, 100) + '...'): task.content 

															: task.content.length > 115 ? (task.content.slice(0, 115) + '...') : task.content
														}}
													</span>
												</v-col>
											</v-row>
											<v-row v-if="0">
												<v-col cols="12" class="text-start py-0" align-self="end">
													<v-icon 
														size="15" 
														class="me-1" 
														:class="{
															'white--text': task.isDone
														}"
													> 
														mdi-clock-time-four-outline  
													</v-icon>
													<span v-if="task.isDone" class="fs-11 white--text">
														{{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
													</span>
													<span class="fs-11" :class="{'white--text': task.isDone}"> 
														/ {{ task.durationInMinute / 60 }} h
													</span>
													
												</v-col>
											</v-row>
											<!--  -->
											<v-row class="">
												<v-col align-self="end" cols="12" class=" py-1">
													<v-row justify="end">
														<v-col cols="auto" class="text-start" align-self="start">
															<v-icon 
																size="15" 
																class="me-1" 
																:class="{
																	'white--text': task.isDone
																}"
															> 
																mdi-clock-time-four-outline  
															</v-icon>
															<span class="fs-11" :class="{'white--text': task.isDone}"> 
																{{ task.durationInMinute / 60 }} h
															</span>
															<span v-if="task.isDone" class="fs-11 white--text">
																/ {{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
															</span>
														</v-col>
														<v-spacer />
														<!-- hide action btn -->
														<v-row 
															v-if="0"
															cols="auto" 
															align="center" 
															class=" py-0 d-flex"
															:class="{
																'justify-center': $vuetify.breakpoint.lg,
																'justify-end mx-1': $vuetify.breakpoint.mdAndDown
															}"
														>
															<v-btn	
																v-if="
																	(
																		$route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
																	) || 
																	(
																		$route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days'))
																	)
																"
																icon
																@click="rowId = day.id; taskId = task.id; dialog = true"
																:disabled="loading"
																:color="task.isDone ? 'white' :  'gray' "
															>
																<v-icon small> mdi-pencil </v-icon>
															</v-btn>

															<v-btn 
																icon 
																v-else 
																@click="rowId = day.id; taskId = task.id; view = true; dialog = true"
																x-small
															>
																<v-icon :color="task.isDone ? 'white' : 'edit-color'"> mdi-eye </v-icon>
															</v-btn>
														
															<v-btn
																v-if="
																	(
																		$route.params.id && moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
																	) || 
																	(
																		$route.params.id && moment().isBefore(moment(startDatePlan).add(2, 'days'))
																	)
																"
																:disabled="loading"
																icon
																@click="taskId = task.id; deleteDialog = true"
																:color="task.isDone ? 'white' :  'gray' "
															>
																<v-icon small> mdi-delete </v-icon>
															</v-btn>
											
															<v-btn
																:disabled="loading"
																icon
																@click="taskId = task.id; status = task.isDone; task.doneLoading = true; changeToDone()"
																:color="task.isDone ? 'white' : 'green' "
																:loading="Boolean(task.doneLoading)"
															>
																<v-icon v-if="task.isDone"> mdi-swap-horizontal </v-icon>
																<v-icon v-if="!task.isDone" small> mdi-check-circle  </v-icon>
															</v-btn>
														</v-row>
													</v-row>
												</v-col>
											</v-row>
										</v-col>
										
									</div>

									<v-btn
										v-if="
										((
											$route.params.id && 
											moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
										) || 
										( 
											$route.params.id && 
											moment().isBefore(moment(startDatePlan).add(2, 'days'))
										)) &&
										day.tasks.map(c => c.durationInMinute).reduce((a, b) => a + b) / 60 <= 10 
										"
										class="align-self-center rounded-lg mx-2"
										width="3px"
										x-small
										height="80px"
										color="success-light white--text"
										@click="resetAll(); rowId = day.id; dialog = true"
										:disabled="loading"
									>
										<v-icon> mdi-plus </v-icon>	
									</v-btn>
								</v-col>
							</v-row>
							<v-divider class="" />
						</v-col>
					</template>
				</v-card-text>
			</v-card>
            </div>
        <div v-if="loading" class="d-flex justify-center align-center" style=" height: 100% ">
            <div>
                <div 
                    :class="{
                        'loader': !$vuetify.theme.dark,
                        'loader-dark': $vuetify.theme.dark
                    }" 
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import rules from '@/helper/validation rules.js'
import { mapState } from 'vuex'
import { userType } from '@/helper/enum'
export default {
	data () {
		return {
			status: null,
			view: false,
			allUserPlan: [],
			previous: false,
			planIsDone: false,
			userType,
			notAllowAddPlan: false,
			currentPlan: [],
			rule: [v => v?.length >= 30 || 'Min 30 characters'],
			submitLoading: false,
			loading: false,
			startDatePlan: null,
			endDatePlan: null,
			planData: {
				startDatePlan: moment(this.moment(this.moment().startOf('week')).subtract(1, 'day')).format('YYYY-MM-DD'),
				endDatePlan: moment(this.moment(this.moment().endOf('week')).subtract(2, 'day')).format('YYYY-MM-DD'),
				isActive: false
			},
			date: null,
			menuPicker: true,
			activePicker: null,

			menuPickerEnd: true,
			activePickerEnd: null,

			newPlanDialog: false,
			deleteDialog: false,
			rules,
			rowId: null,
			dialog: false,
			project: null,
			
			hours: 0,
			taskNo: 0,
			taskId: null,
			myDate: moment().subtract(1, 'days'),
			task: null,
			userIdUser: null,
			planByEmployee: [],
			noPlan: false,

			// table in md and sm size
			headers: [
				{
					text: 'Day',
					value: 'name'
				},
				{
					text: 'Project',
					value: 'tasks'
				},
				{
					text: 'Details',
					value: 'details'
				},
				{
					text: 'time',
					value: 'time'
				},
				{
					text: 'actions',
					value: 'actions'
				}
			],
			dateDate: null,
			allProjects: []
		}
	},

	computed: {
		...mapState({
			userId: state => state.auth.self.id,
			self: state => state.auth.self,
			currentUserProjects: state => state.projects.currentUserProjects,
			plan: state => state.plan.plan,
			userTypeUser: state => state.auth.self.userType,
			usersWithoutPag: state => state.users.usersWithoutPag
		}),
		// noPlan() {
		// 	currentPlan.length === 0
		// },
		// isDone() {
		// 	if(this)
		// }, 

		week () {
			return [
				{
					name: 'Sat',
					id: 1,
					tasks: [
						{
							id: '0819789d-c83b-4880-5625-08dce7862082',
							createdAt: '2024-10-08T11:08:58.2082272',
							updatedAt: null,
							planId: '570079eb-7313-4f48-6d4b-08dce7882201',
							projectId: '00000000-0000-0000-0000-000000000000',
							date: '2024-10-05T00:00:00',
							content: 'planning to set plan to projects',
							durationInMinute: 60,
							taskNo: 0,
							isDone: false,
							actualDuration: null
						},
						{
							id: '0819789d-c83b-4880-5625-08dce7862082',
							createdAt: '2024-10-08T11:08:58.2082272',
							updatedAt: null,
							planId: '570079eb-7313-4f48-6d4b-08dce7882201',
							projectId: '00000000-0000-0000-0000-000000000000',
							date: '2024-10-05T00:00:00',
							content: 'planning to set plan to projects',	
							durationInMinute: 60,
							taskNo: 0,
							isDone: false,
							actualDuration: null
						}
					],
					date: moment(this.startDatePlan).format('YYYY-MM-DD')
				},
				{
					name: 'Sun',
					id: 2,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(1, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Mon',
					id: 3,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(2, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Tue',
					id: 4,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(3, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Wen',
					id: 5,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(4, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Th',
					id: 6,
					tasks: [],
					date: moment(moment(this.startDatePlan).add(5, 'days')).format('YYYY-MM-DD')
				},
				{
					name: 'Undefined',
					id: 7,
					tasks: [],
					date: null
				}
			]
		},

		taskDate () {
			return this.week.find(c => c.id === this.rowId)?.date
		},
		myDraft () {
			let items = []
			if (this.searchText === null) {
				items = this.items
			}
			return items
		}
	},

	methods: {
		getMatchingPlan () {

		},

		moment,
		pushDataInTheWeek (data) {
			// const tasks = data
			// this.week.map(c => (c.tasks = []))
			// for (let i = 0; i < tasks?.length; i++) {
			// 	if (this.week.find(c => moment(moment(c.date).format('YYYY-MM-DD')).isSame(moment(tasks[i].date).format('YYYY-MM-DD'), 'day'))) {
			// 		this.week.find(c => moment(c.date).isSame(tasks[i].date, 'day'))?.tasks.push(
			// 			tasks[i]
			// 		)
			// 	}
			// }
			// return this.week.map(c => ({ ...c, doneLoading: false }))
		}
	},

	created () {
		if (this.userTypeUser === userType.Admin || this.userTypeUser === userType.Administrative) {
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true })
			this.$store.dispatch('projects/fetchAll', { CategoryIds: [], UserId: [] })
		} else {
			this.$store.dispatch('projects/fetchCurrentUserProjects')
		}
		
		this.$store.dispatch('plan/fetchAll')
		this.$store.dispatch('plan/fetchActivePlanForUser', { userId: this.userId }).then((data) => {
			this.allUserPlan = data
			if (data?.length !== 0) {
				// Assuming there is always one active plan
				if ((!this.$route.params.id && data.length) || (this.$route.params.id !== data[0].id && data.length)) {
					// this.$router.push({
					// 	name: 'plan-matching',
					// 	params: { id: data[0].id }
					// })
				}

				this.currentPlan = data
				this.startDatePlan = data[0].startDate
				this.endDatePlan = data[0].endDate

				if (data[0]?.plannedTasks.length) {
					this.pushDataInTheWeek(data[0]?.plannedTasks)
				}
				if (this.week.map(c => c.date).includes(this.moment().format('YYYY-MM-DD'))) {
					this.notAllowAddPlan = true
				} else {
					// this.loading = true
					// this.$store.dispatch('plan/update', {
					// 	id: this.$route.params.id, 
					// 	startDate: data[0]?.startDate,
					// 	endDate: data[0]?.endDate,
					// 	isActive: false, 
					// 	userId: this.userId
					// }).then(() => {
					// 	this.notAllowAddPlan = false
					// }).finally(() => {
					// 	this.loading = false
					// })
				}
				return this.week
			} else {
				this.planIsDone = true
			}
		})
	}
}
</script>

<style scoped lang="scss">
/* HTML: <div class="loader"></div> */

/* HTML: <div class="loader"></div> */
fieldset {
	color: rgba(216, 216, 216, 0.507) !important
}
#demo {
	width: 100% !important
}
.w-100 {
	width: 100%
}
.hover:hover {
	border-radius: 30px;
}

// style
.week-card {
	height: 850
}
.h-one-row {
	height: 150px
}
.task-card {
	height: 90px; 
	// background-color: #
}
.h-auto {
	height: auto;
}
.task-card-done {
	height: 90px;
	background-color: #2E9859;
}
.no-task-style {
	align-content: center; 
	color: #0B759D; 
}
.no-task-style-green {	
	align-content: center; 
	color: white; 
}
.bg-light-green {
	background-color: #8cc3a2; 
}
.bg-light-blue {
	background-color: #E8F4F8; 
}
.bg-light-grey {
	background-color: #878787;
}
.fs-11 {
	font-size: 11px
}

.style-small-draft-card {
	width: 100%; 
	height: 65px; 
	border: 3px solid #f6f6f6  
}
.droptarget {
	float: left; 
	width: 100%; 
	height: 100px;
	margin: 15px;
	padding: 10px;
	// border: 1px solid #aaaaaa
}

.scroll-style {
    float:left;
    width: 100%;
    overflow-y: auto;
    height: auto;
}
</style>
